import * as React from 'react'

function SvgLogin(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 30 30" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.556 16.065a1.495 1.495 0 00.321-1.66 1.493 1.493 0 00-.323-.472L14.062 7.44a1.5 1.5 0 10-2.122 2.122l3.94 3.939H3.5a1.5 1.5 0 000 3h12.379l-3.94 3.94a1.5 1.5 0 002.122 2.12l6.495-6.495z"
        fill="currentColor"
      />
      <path
        d="M20.5 25a1.5 1.5 0 000 3H26a2 2 0 002-2V4a2 2 0 00-2-2h-5.5a1.5 1.5 0 000 3H25v20h-4.5z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgLogin
